<template>
  <div id="basic">
    <div class="top_name" v-loading="toploading">
      <div class="name_list" v-for="(item,i) in toplis" :key="i">
        <div class="name_list_x">
          <div class="name_color">{{item.title}}</div>
          <div class="name_color_s">{{item.value}}</div>
        </div>
        <div class="name_list_s">
          <div>{{item.sub_title}}</div>
          <div class="name_list_s_1">{{item.sub_value}}</div>
        </div>
      </div>
    </div>
    <div class="top_div_basic" v-loading="listloading">
      <div class="basic_top">
        <div>店铺管理</div>
        <div style="color: #1890ff; cursor: pointer;" @click="clickTop(datalist.id)">编辑</div>
      </div>
      <div class="basic_value">
        <div class="basic_value_s">
          <span>名称:</span>
          <span>{{datalist.name}}</span>
        </div>
        <div class="basic_value_img">
          <img v-for="(item,i) in datalist.images" :key="i" :src="$getStorageUrl(item)" />
        </div>
        <div class="basic_value_s">
          <span>地址:</span>
          <span>{{datalist.province}} {{datalist.province!==datalist.city&&datalist.city||''}} {{datalist.district}} {{datalist.address}}</span>
        </div>
        <div class="basic_value_s">
          <span>联系方式:</span>
          <span>{{datalist.contact_number}}</span>
        </div>
        <div class="basic_value_s">
          <span>营业时间:</span>
          <span>{{datalist.open_time_from}}-{{datalist.open_time_to}}</span>
        </div>
        <div class="basic_value_s">
          <span>创建时间:</span>
          <span>{{datalist.created_at}}</span>
        </div>
          <div class="basic_value_s">
          <span>外卖配送:</span>
          <span>{{datalist.can_delivery ? '关闭':'开启'}}</span>
        </div>
        <div class="basic_value_s">
          <span>更新时间:</span>
          <span>{{datalist.updated_at}}</span>
        </div>
        <div class="basic_value_s" v-if="datalist.deleted_at">
          <span>删除时间:</span>
          <span>{{datalist.deleted_at}}</span>
        </div>
      </div>
    </div>
    <!-- <div class="top_div_basic" v-loading="listloading">
      <div class="basic_top">
        <div>店长信息</div>
        <div style="color: rgba(0, 0, 0, 0.7);font-size:10px; cursor: pointer;">修改请联系平台</div>
      </div>
      <div class="basic_value">
        <div class="basic_value_s">
          <span>名称</span>
          <span>{{datalist.name}}</span>
          <span style="margin-left: 100px; margin-right: 20px;">手机号:</span>
          <span>{{datalist.telephone}}</span>
        </div>
      </div>
    </div>
    <div class="top_div_basic" v-loading="listloading">
      <div class="basic_top">
        <div>股东信息</div>
        <div style="color: rgba(0, 0, 0, 0.7);font-size:10px; cursor: pointer;">修改请联系平台</div>
      </div>
      <div class="basic_value">
        <div class="basic_value_s">
      
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';

export default {
  name: 'dailymenu',
  components: {},
  data() {
    return {
      toplis: [],
      datalist: {},
      toploading: false,
      listloading: false,
    };
  },
  methods: {
    // topList() {
    //   this.toploading = true;
    //   const url = this.$userList.user_restaurant + '/' + this.$route.params.id;
    //   this.$http.get(url).then(res => {
    //     this.toploading = false;
    //     if (res.code === 200) {
    //       this.toplis = res.data;
    //     } else {
    //       res.message && this.$alert(res.message);
    //     }
    //   });
    // },
    getList() {
      // this.listloading = true;
      let data = JSON.parse(localStorage.getItem('basics_min'));
      data.created_at = fecha.format(
        new Date(data.created_at),
        'yyyy-MM-dd HH:mm:ss'
      );
      data.updated_at = fecha.format(
        new Date(data.updated_at),
        'yyyy-MM-dd HH:mm:ss'
      );
      if (data.deleted_at) {
        data.deleted_at = fecha.format(
          new Date(data.deleted_at),
          'yyyy-MM-dd HH:mm:ss'
        );
      }
      console.log();
      this.datalist = data;
      // const url = this.$userList.user_restaurants
      // this.$http.get(url).then(res => {
      //   this.listloading = false;
      //   if (res.code === 200) {
      //     = res.data;
      //   } else {
      //     res.message && this.$alert(res.message);
      //   }
      // });
    },
    clickTop(id) {
      this.$router.push({ path: '/shop/basic/update/' + id });
    },
  },
  created() {
    // this.topList();
    this.getList();
    this.$root.setheadName();
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: auto;
  position: relative;
}
.top_div_basic {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  min-height: 200px;
}
.basic_top {
  width: 100%;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: solid 1px rgb(160, 160, 160);
}
.basic_value,
.basic_value_s {
  width: 100%;
  height: auto;
}
.basic_value_s {
  margin-top: 20px;
}
.basic_value_s span:nth-child(1) {
  margin-right: 20px;
}
.top_name {
  width: 100%;
  height: auto;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  box-sizing: border-box;
  padding: 20px 0;
}
.name_list {
  flex: 1;
  height: 100%;
  border-right: solid 1px rgba(0, 0, 0, 0.5);
  font-size: 20px;
}
.name_color {
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
  margin-bottom: 10px;
}
.name_color_s {
  color: rgba(0, 0, 0, 1);
  font-size: 30px;
  margin-bottom: 10px;
}
.name_list_s {
  margin: 0 20px;
  display: flex;
  color: rgba(41, 39, 39, 0.952);
  padding-top: 20px;
  font-size: 15px;
  border-top: solid 1px rgba(0, 0, 0, 0.3);
}
.name_list_x {
  margin: 0 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
}
.name_list_s_1 {
  margin-left: 10px;
}
.name_list:last-child {
  border-right: none;
}
.basic_value_img {
  margin-top: 10px;
}
.basic_value_img > img {
  width: 70px;
  height: 70px;
  margin-right: 10px;
  background: rgba(83, 120, 243, 0.3);
}
</style>
